import { render, staticRenderFns } from "./batchAction.vue?vue&type=template&id=9604c662&scoped=true"
import script from "./batchAction.vue?vue&type=script&lang=js"
export * from "./batchAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9604c662",
  null
  
)

export default component.exports